import { Navigate, useLocation } from "react-router-dom";
import AuthInstance from "../utilities/auth";

//URLS PUBLICAS
const NO_NAVBAR_SIDEBAR_ROUTES = ["/login", "/agente", "/gestionCobranza", "/ucontact", "/gestionVenta"];

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token =  AuthInstance.getToken()
  const expireSession =  AuthInstance.userSession()
  
  if (!token && !NO_NAVBAR_SIDEBAR_ROUTES.includes(location.pathname)) {
    return <Navigate to="/login" />;
  }
  else if (!expireSession && !NO_NAVBAR_SIDEBAR_ROUTES.includes(location.pathname)) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default PrivateRoute;
